(function () {
  var debounceTimer = null;
  var observer = null;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function injectCSS() {
    if (document.getElementById('chase-variant-media-filter-css')) return;

    var style = document.createElement('style');
    style.id = 'chase-variant-media-filter-css';
    style.textContent = '.variant-media-hidden{display:none!important;}';
    document.head.appendChild(style);
  }

  function getSelectedColor() {
    var checked = document.querySelector('input[type="radio"][name^="Color-"]:checked');
    if (checked) return checked.value || null;

    checked = Array.prototype.slice.call(
      document.querySelectorAll('input[type="radio"]:checked')
    ).find(function (input) {
      return (input.name || '').toLowerCase().indexOf('color') > -1;
    });
    if (checked) return checked.value || null;

    var colorSelect = Array.prototype.slice.call(
      document.querySelectorAll('select')
    ).find(function (select) {
      return (select.name || '').toLowerCase().indexOf('color') > -1;
    });
    if (colorSelect) return colorSelect.value || null;

    return null;
  }

  function isGenericValue(value) {
    var normalized = normalize(value);
    return (
      normalized === '' ||
      normalized === 'main' ||
      normalized === 'default' ||
      normalized === 'featured'
    );
  }

  function matchesColor(rawValue, selectedColor) {
    var normalizedValue = normalize(rawValue);
    var handledValue = handleize(rawValue);
    var normalizedColor = normalize(selectedColor);
    var handledColor = handleize(selectedColor);

    return normalizedValue === normalizedColor || handledValue === handledColor;
  }

  function getCarouselSlides() {
    return Array.prototype.slice.call(
      document.querySelectorAll('slideshow-slide[ref="slides[]"]')
    );
  }

  function getGridItems() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.media-gallery__grid > li[ref="media[]"]')
    );
  }

  function getMediaValue(node) {
    return (
      node.getAttribute('data-media-alt') ||
      node.getAttribute('data-media-alt-handle') ||
      ''
    );
  }

  function getMatchingNodes(nodes, selectedColor) {
    if (!selectedColor) return nodes;

    var matchingNodes = nodes.filter(function (node) {
      var mediaValue = getMediaValue(node);
      return isGenericValue(mediaValue) || matchesColor(mediaValue, selectedColor);
    });

    return matchingNodes.length ? matchingNodes : nodes;
  }

  function getCurrentVisibleSlide(slides) {
    return (
      slides.find(function (slide) {
        return !slide.hidden && slide.getAttribute('aria-hidden') === 'false';
      }) ||
      null
    );
  }

  function filterGridItems(nodes, selectedColor) {
    if (!nodes.length) return;

    var nodesToShow = getMatchingNodes(nodes, selectedColor);

    nodes.forEach(function (node) {
      var shouldShow = nodesToShow.indexOf(node) > -1;
      node.classList.toggle('variant-media-hidden', !shouldShow);
    });
  }

  function filterCarouselSlides(slides, selectedColor) {
    if (!slides.length) return;

    var slidesToShow = getMatchingNodes(slides, selectedColor);
    var currentVisibleSlide = getCurrentVisibleSlide(slides);
    var nextActiveSlide =
      currentVisibleSlide && slidesToShow.indexOf(currentVisibleSlide) > -1
        ? currentVisibleSlide
        : slidesToShow[0] || null;

    slides.forEach(function (slide) {
      var shouldShow = slidesToShow.indexOf(slide) > -1;
      slide.classList.toggle('variant-media-hidden', !shouldShow);
      slide.hidden = !shouldShow;
      slide.setAttribute('aria-hidden', 'true');
    });

    if (nextActiveSlide) {
      nextActiveSlide.hidden = false;
      nextActiveSlide.classList.remove('variant-media-hidden');
      nextActiveSlide.setAttribute('aria-hidden', 'false');
    }
  }

  function disconnectObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function watchGallery() {
    disconnectObserver();

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    observer = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (mutation) {
        return mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length);
      });

      if (shouldRun) {
        runFilterDebounced();
      }
    });

    observer.observe(gallery, {
      childList: true,
      subtree: true
    });
  }

  function filterMedia() {
    var selectedColor = getSelectedColor();
    var carouselSlides = getCarouselSlides();
    var gridItems = getGridItems();

    filterCarouselSlides(carouselSlides, selectedColor);
    filterGridItems(gridItems, selectedColor);

    window.dispatchEvent(new Event('resize'));
  }

  function runFilterDebounced() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      filterMedia();
    }, 120);
  }

  function handleChange(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var isColorRadio =
      target.matches('input[type="radio"][name^="Color-"]') ||
      (target.matches('input[type="radio"]') &&
        (target.getAttribute('name') || '').toLowerCase().indexOf('color') > -1);

    var isColorSelect =
      target.matches('select') &&
      (target.getAttribute('name') || '').toLowerCase().indexOf('color') > -1;

    if (isColorRadio || isColorSelect) {
      runFilterDebounced();
    }
  }

  injectCSS();

  document.addEventListener('change', handleChange, true);
  document.addEventListener('input', handleChange, true);

  document.addEventListener('DOMContentLoaded', function () {
    watchGallery();
    runFilterDebounced();
  });

  document.addEventListener('shopify:section:load', function () {
    watchGallery();
    runFilterDebounced();
  });

  window.addEventListener('load', function () {
    watchGallery();
    runFilterDebounced();
  });

  window.addEventListener('popstate', function () {
    watchGallery();
    runFilterDebounced();
  });

  watchGallery();
  runFilterDebounced();
})();